import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RuleAdapter, Rule } from 'src/app/models/rule.model';

@Injectable({
  providedIn: 'root'
})
export class RulesService {

  private _controller = 'rule-engine';

  constructor(private _http: HttpClient, private _adapter: RuleAdapter) { }

  get(): Observable<Rule[]>{
    return this._http.get<Rule[]>(this._controller).pipe(map((data: any) => data.map(item => this._adapter.adapt(item))));
  }

  getById(id: Number): Observable<Rule>{
    return this._http.get<Rule>(this._controller + '/' + id).pipe(map(item => this._adapter.adapt(item)));
  }

  save(data: any): Observable<Object>{
    return this._http.post<Object>(this._controller, this._adapter.reverseAdapt(data));
  }

  update(data: Rule): Observable<Object> {
    return this._http.put<Object>(this._controller, this._adapter.reverseAdapt(data)).pipe(map(item => this._adapter.adapt(item)));
  }
  
  delete(id: any): Observable<Object>{
    return this._http.delete<Object>(this._controller + '/' + id);
  }

}